import { render } from "./ProductItemListWithSelect.vue?vue&type=template&id=036ea3a2&ts=true"
import script from "./ProductItemListWithSelect.vue?vue&type=script&lang=ts"
export * from "./ProductItemListWithSelect.vue?vue&type=script&lang=ts"

import "./ProductItemListWithSelect.vue?vue&type=style&index=0&id=036ea3a2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__